'use client';

import Image from 'next/image';
import Link from 'next/link';

const PartnersCollaboratorsSection = () => {
  const logos = [
    {
      src: "/images/gais.webp",
      alt: "Global AI Show",
      link: "https://www.globalaishow.com",
    },
    {
      src: "/images/gbs.webp",
      alt: "Global Blockchain Show",
      link: "https://www.globalblockchainshow.com",
    },
    {
      src: "/images/ggs-logo.webp",
      alt: "Global Game Show",
      link: "https://www.globalgamesshow.com",
    },
    {
      src: "/images/corinium.webp",
      alt: "Corinium",
      link: "https://www.coriniumintelligence.com",
      large: true,
    },
    {
      src: "/images/rework.webp",
      alt: "Rework",
      link: "https://www.re-work.co",
      large: true,
    },
  ];

  return (
    <section data-component-id="src/app/PartnersCollaboratorsSection.jsx:38:4" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="38" data-component-end-line="98" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20py-%5B60px%5D%20sm%3Apy-%5B20px%5D%20lg%3Apy-%5B20px%5D%22%7D"
      id="partners"
      className="w-full py-[60px] sm:py-[20px] lg:py-[20px]"
      style={{
        background: 'linear-gradient(to bottom, #D9CFFF 0%, #FFFFFF 50%, #D9CFFF 100%)',
      }}
    >
      <div data-component-id="src/app/PartnersCollaboratorsSection.jsx:45:6" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="45" data-component-end-line="97" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B10px%5D%20justify-start%20items-center%20w-full%22%7D" className="flex flex-col gap-[10px] justify-start items-center w-full">
        
        {/* Section Header */}
        <div data-component-id="src/app/PartnersCollaboratorsSection.jsx:48:8" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="48" data-component-end-line="52" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
          <h2 data-component-id="src/app/PartnersCollaboratorsSection.jsx:49:10" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="49" data-component-end-line="51" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B30px%5D%20lg%3Atext-%5B40px%5D%20font-%5B'Michroma'%5D%20font-normal%20leading-%5B29px%5D%20sm%3Aleading-%5B43px%5D%20lg%3Aleading-%5B57px%5D%20text-%5B%236f4afc%5D%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D" className="text-[20px] sm:text-[30px] lg:text-[40px] font-['Michroma'] font-normal leading-[29px] sm:leading-[43px] lg:leading-[57px] text-[#6f4afc]">
            Past Partners & Collaborators
          </h2>
        </div>

        {/* Logos Section */}
        <div data-component-id="src/app/PartnersCollaboratorsSection.jsx:55:8" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="55" data-component-end-line="96" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20flex%20justify-center%20items-center%20min-h-%5B100px%5D%20sm%3Amin-h-%5B130px%5D%20lg%3Amin-h-%5B120px%5D%22%7D" className="relative w-full flex justify-center items-center min-h-[100px] sm:min-h-[130px] lg:min-h-[120px]">
          
          {/* Background Circle */}
          <Image data-component-id="src/app/PartnersCollaboratorsSection.jsx:58:10" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="58" data-component-end-line="65" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Fbackground-decoration.svg%22%2C%22alt%22%3A%22background-decoration%22%2C%22className%22%3A%22absolute%20w-%5B228px%5D%20sm%3Aw-%5B126px%5D%20lg%3Aw-%5B126px%5D%20h-%5B228px%5D%20sm%3Ah-%5B126px%5D%20lg%3Ah-%5B126px%5D%20z-0%22%7D" 
            src="/images/background-decoration.svg" 
            alt="background-decoration"
            width={126}
            height={126}
            className="absolute w-[228px] sm:w-[126px] lg:w-[126px] h-[228px] sm:h-[126px] lg:h-[126px] z-0"
            unoptimized
          />

          {/* Logos Grid */}
          <div data-component-id="src/app/PartnersCollaboratorsSection.jsx:68:10" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="68" data-component-end-line="95" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-3%20md%3Agrid-cols-5%20gap-4%20sm%3Agap-6%20lg%3Agap-8%20z-10%20w-full%20max-w-%5B1154px%5D%20px-4%20sm%3Apx-8%20lg%3Apx-16%22%7D" className="grid grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6 lg:gap-8 z-10 w-full max-w-[1154px] px-4 sm:px-8 lg:px-16">
            {logos.map((logo, index) => (
              <Link data-component-id="src/app/PartnersCollaboratorsSection.jsx:70:14" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="70" data-component-end-line="93" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20w-full%20h-%5B110px%5D%20sm%3Ah-%5B140px%5D%20lg%3Ah-%5B110px%5D%20p-4%20sm%3Ap-6%20lg%3Ap-4%20mx-auto%20overflow-hidden%20bg-white%20rounded-md%22%7D"
                key={index}
                href={logo.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex justify-center items-center w-full h-[110px] sm:h-[140px] lg:h-[110px] p-4 sm:p-6 lg:p-4 mx-auto overflow-hidden bg-white rounded-md"
                // style={{
                //   background: '#FFFFFF',
                //   borderRadius: '40px',
                //   boxShadow: '0 2px 16px 0 rgba(111, 74, 252, 0.10), 0 1px 4px 0 rgba(0,0,0,0.06)',
                //   border: '1.5px solid rgba(217, 207, 255, 0.7)',
                // }}
              >
                <Image data-component-id="src/app/PartnersCollaboratorsSection.jsx:83:16" data-component-path="src/app/PartnersCollaboratorsSection.jsx" data-component-line="83" data-component-end-line="92" data-component-file="PartnersCollaboratorsSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%7D"
                  src={logo.src}
                  alt={logo.alt}
                  width={180}
                  height={302}
                  unoptimized
                  className={`object-contain transition-all duration-300 ${
                    logo.large ? 'scale-125' : 'max-h-full w-full'
                  }`}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersCollaboratorsSection;